module.exports = __webpack_public_path__ + "static/media/chokha6.4752680d.webp";